/**
 * Decode Unicode escape sequences (e.g. \u0020) in backend-derived display strings
 * to prevent raw "\uXXXX" from appearing in the UI.
 */
export function decodeUnicodeEscapes(s: string | null | undefined): string {
  if (s == null) return '';
  if (typeof s !== 'string') return String(s);
  return s.replace(/\\u[\dA-Fa-f]{4}/g, (m) =>
    String.fromCharCode(parseInt(m.slice(2), 16))
  );
}
